/**
 * CMSD dynamic header name.
 *
 *
 * @beta
 */
export const CMSD_DYNAMIC = 'CMSD-Dynamic'
